/**
 * @warcarp/ui — public surface
 *
 * Re-export everything that consumers (apps/mobile) should be able to import
 * directly from '@warcarp/ui'.
 */

export {
  PLAYER_COLORS,
  LOCKED_PLAYER_SLOTS,
  clampPlayerSlot,
} from './colors';

export type { PlayerSlot, PlayerPattern } from './colors';

export { PlayerColorChip } from './components/PlayerColorChip';
export type { PlayerColorChipProps, ChipSize } from './components/PlayerColorChip';

export { BrandMark, brandMarkXml } from './components/BrandMark';
export type { BrandMarkProps, BrandMarkKind } from './components/BrandMark';
export { BRAND_COLORS, BRAND_LOGO_TEXT_CENTER, BRAND_MARKS, BRAND_VERSION } from './brand/marks.generated';
export { SupportDesk, SupportButton, SupportConversation, SupportTheme, supportPalette } from './components/SupportDesk';
export type { SupportRequest } from './components/SupportDesk';
export { timeAgo } from './timeAgo';
export { NewsBody } from './components/NewsBody';
